"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  "button.delete": "Eliminar",
  "button.download": "Descargar",
  "button.close": "Cerrar",
  "button.submit": "Enviar",
  "button.help": "Ayuda",
  "button.rotate": "Girar",
  "button.bookmarks": "Marcadores",
  "button.print": "Imprimir",
  "preview.nextDocument": "Siguiente Documento",
  "preview.notAvailable": "Vista previa no disponible para este tipo de archivo.",
  "preview.passwordRequired": "Introduzca su contraseña",
  "preview.passwordDesc": "Ingrese una contraseña para acceder a este documento.",
  "preview.previousDocument": "Documento Anterior",
  "loading": "Subiendo",
  "page": "Página"
};
exports.default = _default;
